import { useQueryClient } from '@tanstack/react-query';

/** Invalida tudo o que mostra o lead depois de uma edição na ficha. */
export function useLeadRefresh(leadId: string) {
  const queryClient = useQueryClient();
  return () => {
    queryClient.invalidateQueries({ queryKey: ['lead', leadId] });
    queryClient.invalidateQueries({ queryKey: ['lead-history', leadId] });
    queryClient.invalidateQueries({ queryKey: ['lead-relations', leadId] });
    queryClient.invalidateQueries({ queryKey: ['leads'] });
  };
}
